import React, { createContext, useState, useContext, useCallback } from 'react';

const ToastContext = createContext();

export const useToast = () => {
        const context = useContext(ToastContext);
        if (!context) {
                throw new Error('useToast must be used within a ToastProvider');
        }
        return context;
};

export const ToastProvider = ({ children }) => {
        const [toast, setToast] = useState(null);

        const showToast = useCallback((status, message, duration = 5000) => {
                setToast({ status, message });
                setTimeout(() => {
                        setToast(null);
                }, duration);
        }, []);

        const hideToast = useCallback(() => {
                setToast(null);
        }, []);

        return (
                <ToastContext.Provider value={{ toast, showToast, hideToast }}>
                        {children}
                </ToastContext.Provider>
        );
};

export default ToastContext;
